import { all, takeLeading } from 'redux-saga/effects';

import * as constants from './constants';
import { startToggleHoursSaga } from './saga.toggleHours';

export function* watcher() {
  yield all([takeLeading(constants.START_TOGGLE_HOURS, startToggleHoursSaga)]);
}
